
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policy/company",
      function () {
        return require("private-next-pages/policy/company.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policy/company"])
      });
    }
  